
;
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-3y1v39h9k3m';
                    document.querySelectorAll('.ecom-3y1v39h9k3m').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-s8pmg3f7d1';
                    document.querySelectorAll('.ecom-s8pmg3f7d1').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-oegqaay3urh';
                    document.querySelectorAll('.ecom-oegqaay3urh').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-mjnw3xtlev';
                    document.querySelectorAll('.ecom-mjnw3xtlev').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-i25zrpsnzgj';
                    document.querySelectorAll('.ecom-i25zrpsnzgj').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-s1znvz32dyh';
                    document.querySelectorAll('.ecom-s1znvz32dyh').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-vwodumxlq2d';
                    document.querySelectorAll('.ecom-vwodumxlq2d').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-xuwyztav39';
                    document.querySelectorAll('.ecom-xuwyztav39').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-6gg6l7j7i4';
                    document.querySelectorAll('.ecom-6gg6l7j7i4').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-cq7z13hqfhu';
                    document.querySelectorAll('.ecom-cq7z13hqfhu').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-cyg6sm9406';
                    document.querySelectorAll('.ecom-cyg6sm9406').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-vjjp1h580o';
                    document.querySelectorAll('.ecom-vjjp1h580o').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-px6tj2z1mg7';
                    document.querySelectorAll('.ecom-px6tj2z1mg7').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-2saqcjcg3fo';
                    document.querySelectorAll('.ecom-2saqcjcg3fo').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-jr5tvt1ybw9';
                    document.querySelectorAll('.ecom-jr5tvt1ybw9').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-jakzwcttwsb';
                    document.querySelectorAll('.ecom-jakzwcttwsb').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-gs2c3bzbf3k';
                    document.querySelectorAll('.ecom-gs2c3bzbf3k').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-cug9zuq93m';
                    document.querySelectorAll('.ecom-cug9zuq93m').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-zhuo91yfe5f';
                    document.querySelectorAll('.ecom-zhuo91yfe5f').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-tyr245nfm7';
                    document.querySelectorAll('.ecom-tyr245nfm7').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-lue0trwvdt';
                    document.querySelectorAll('.ecom-lue0trwvdt').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            